import createLucideIcon from '../createLucideIcon';

/**
 * @component @name ArchiveRestore
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iNSIgeD0iMiIgeT0iNCIgcng9IjIiIC8+CiAgPHBhdGggZD0iTTEyIDEzdjciIC8+CiAgPHBhdGggZD0ibTkgMTYgMy0zIDMgMyIgLz4KICA8cGF0aCBkPSJNNCA5djlhMiAyIDAgMCAwIDIgMmgyIiAvPgogIDxwYXRoIGQ9Ik0yMCA5djlhMiAyIDAgMCAxLTIgMmgtMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/archive-restore
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArchiveRestore = createLucideIcon('ArchiveRestore', [
  [
    'rect',
    { width: '20', height: '5', x: '2', y: '4', rx: '2', key: 'uhwcea' },
  ],
  ['path', { d: 'M12 13v7', key: '1arz7h' }],
  ['path', { d: 'm9 16 3-3 3 3', key: '1idcnm' }],
  ['path', { d: 'M4 9v9a2 2 0 0 0 2 2h2', key: 'qxnby6' }],
  ['path', { d: 'M20 9v9a2 2 0 0 1-2 2h-2', key: 'gz3jmx' }],
]);

export default ArchiveRestore;
